import { Loadable } from 'foundations-components/transitional/utils/Loadable';
export const AsyncDisqualifiedLeadFollowUpModal = Loadable({
  loader: () => import('./DisqualifiedLeadFollowUpModal').then(mod => mod.DisqualifiedLeadFollowUpModal)
});